/**
 * Session middleware - Protects routes that require authentication
 * Redirects to home page if user is not authenticated
 */
export default defineNuxtRouteMiddleware(() => {
  // Only run on client-side to ensure session store is hydrated
  if (process.server) {
    return;
  }

  const sessionStore = useSessionStore();
  const isAuth = sessionStore.getAuth();

  // If user is not logged in, redirect to home page
  if (!isAuth) {
    return navigateTo('/');
  }
});
